import { AloftDate, AloftTime, isDefined } from '@aloft/toolkit-shared';

import { TkOrderListing, Tkv2SortState } from '../types.ts';
import { getTkv2SortAccessor } from './getTkv2SortAccessor.ts';

export const sortTkOrderListings = (orders: TkOrderListing[], { field, dir }: Tkv2SortState) =>
  [...orders].sort((a, b) => {
    // Always put legacy orders at the bottom
    if (a.type === 'legacy' && b.type === 'tkv2') return 1;
    if (b.type === 'legacy' && a.type === 'tkv2') return -1;

    const aVal = getTkv2SortAccessor(field)(a);
    const bVal = getTkv2SortAccessor(field)(b);

    if (dir === 'asc') {
      if (isDefined(aVal) && isDefined(bVal)) {
        if (AloftDate.isAloftDate(aVal) && AloftDate.isAloftDate(bVal)) {
          return aVal.compare(bVal);
        }

        if (AloftTime.isAloftTime(aVal) && AloftTime.isAloftTime(bVal)) {
          return aVal.compare(bVal);
        }

        return aVal < bVal ? -1 : 1;
      }

      if (isDefined(aVal)) return -1;
      if (isDefined(bVal)) return 1;
      return 0;
    }

    if (isDefined(aVal) && isDefined(bVal)) {
      if (AloftDate.isAloftDate(aVal) && AloftDate.isAloftDate(bVal)) {
        return bVal.compare(aVal);
      }

      if (AloftTime.isAloftTime(aVal) && AloftTime.isAloftTime(bVal)) {
        return bVal.compare(aVal);
      }

      return aVal > bVal ? -1 : 1;
    }

    if (isDefined(aVal)) return 1;
    if (isDefined(bVal)) return -1;
    return 0;
  });
